import { getSmartrrShopifyAuthenticationRedirectUrl } from "@smartrr/shared/utils/getShopifyAppUrl";

import { vendorPortalFrontendRedirect } from "../vendorPortalFrontendRedirect";

// used to log into a different store than the one presently logged into

export function redirectToShopifyAuth(shopUrl: string, openInNewTab = false): void {
  return vendorPortalFrontendRedirect(getSmartrrShopifyAuthenticationRedirectUrl(shopUrl), openInNewTab);
}
